import { Button, Checkbox } from "@shopify/polaris"

import { ComponentType, Switch, withFeatureAuthenticator } from "@/component"

// todo ts 专家帮忙研究一下泛型高阶组件
export const AuthButton = withFeatureAuthenticator(/* polaris-migrator: Unable to migrate the following expression. Please upgrade manually. */
  Button, ComponentType.BUTTON)
export const AuthCheckbox = withFeatureAuthenticator((Checkbox as (props: any) => JSX.Element), ComponentType.CHECKBOX)
export const AuthSwitch = withFeatureAuthenticator((Switch as (props: any) => JSX.Element), ComponentType.SWITCH)
